<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
      :height="getTableHeight(165)"
      size="small"
      fit
      row-key="Id"
    >
      <el-table-column type="expand">
        <template slot-scope="scope">
          <div class="shopurl">
            商户端地址：{{
              "https://shop.koipy.com/TourDiyTab/" + scope.row.Eid + "/"
            }}
          </div>
          <el-button
            type="primary"
            style="margin-bottom: 5px"
            @click="openProduct(scope.row.Name, scope.row.Id)"
            >产品管理</el-button
          >
          <el-button
            type="primary"
            style="margin-bottom: 5px"
            @click="openShippingTime(scope.row.Name, scope.row.Id)"
            >配送时段</el-button
          >
          <el-button
            type="primary"
            style="margin-bottom: 5px"
            @click="openShopFirstDerate(scope.row.Name, scope.row.Id)"
            >新客首单活动</el-button
          >
          <el-button
            type="primary"
            style="margin-bottom: 5px"
            @click="openShopDerate(scope.row.Name, scope.row.Id)"
            >满减活动</el-button
          >
          <el-button
            type="primary"
            @click="openShopLabel(scope.row.Name, scope.row.Id)"
            >标签管理</el-button
          >
        </template>
      </el-table-column>
      <el-table-column :label="$t('Cover')" width="100">
        <template slot-scope="scope">
          <div
            v-if="scope.row.Cover != null && scope.row.Cover != ''"
            class="coverimg"
            :style="{
              backgroundImage: 'url(' + baseCoverUrl + scope.row.Cover + ')',
            }"
          ></div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Name')" min-width="100">
        <template slot-scope="scope">{{ field(scope.row.Name) }}</template>
      </el-table-column>
      <el-table-column
        :label="$t('balance')"
        width="80"
        prop="Balance"
        sortable
      >
        <template slot-scope="scope">
          <span class="text_red">s${{ scope.row.Balance }}</span></template
        >
      </el-table-column>
      <el-table-column :label="$t('Mode')" width="60">
        <template slot-scope="scope">{{
          $t("Order.ModeList")[scope.row.Mode]
        }}</template>
      </el-table-column>
      <el-table-column label="配送" width="100">
        <template slot-scope="scope">{{
          $t("Shop.DeliveryModelList")[scope.row.DeliveryModel]
        }}</template>
      </el-table-column>
      <el-table-column
        :label="$t('Shop.LowestPrice')"
        width="100"
        prop="LowestPrice"
      >
        <template slot-scope="scope">
          <span>s$ {{ scope.row.LowestPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column label="运费减免比例%" width="120">
        <template slot-scope="scope"
          >{{ scope.row.FreightDerate * 100 }}%</template
        >
      </el-table-column>
      <el-table-column
        :label="$t('Shop.OrderNumber')"
        width="100"
        prop="OrderNumber"
      ></el-table-column>
      <el-table-column prop="Reco" label="推荐" width="60">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Reco ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.Reco ? "是" : "否" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="Weight" label="权重" width="70">
        <template slot-scope="scope">
          <el-tag type="warning" disable-transitions>{{
            scope.row.Weight
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="小程序码" width="80">
        <template slot-scope="scope">
          <el-button
            type="info"
            icon="fa fa-qrcode"
            size="small"
            @click="openQrCode(scope.row.Eid, 1)"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column label="内部预览" width="80">
        <template slot-scope="scope">
          <el-button
            type="info"
            icon="fa fa-qrcode"
            size="small"
            @click="openQrCode(scope.row.Eid, 2)"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column prop="Enabled" label="状态" width="65">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Enabled ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.Enabled ? "正常" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total,prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>
    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="150px"
        ref="editForm"
        size="small"
      >
        <LangTabs>
          <template v-slot:main="slot">
            <el-form-item
              :label="$t('Name')"
              :prop="'Name.' + slot.langkey"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Name'),
              }"
            >
              <el-input v-model="editForm.Name[slot.langkey]"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Cover')"
              prop="Cover"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Cover'),
              }"
            >
              <div class="upload-img-form">
                <el-upload
                  class="upload-img"
                  :auto-upload="false"
                  action="xxx"
                  list-type="picture"
                  :show-file-list="false"
                  :on-change="uphandleChange"
                  :style="{
                    backgroundImage:
                      'url(' + baseEditCoverUrl + editForm.EditCover + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'contain',
                  }"
                  accept="image/png, image/gif, image/jpg, image/jpeg"
                >
                  <i
                    v-show="!editForm.EditCover"
                    class="el-icon-upload avatar-uploader-icon"
                  ></i>
                  <i
                    v-show="editForm.EditCover"
                    class="el-icon-refresh avatar-uploader-icon"
                  ></i>
                  <div
                    v-show="!editForm.EditCover"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadImgLabel") }}
                  </div>
                  <div
                    v-show="editForm.EditCover"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadChoose") }}
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="商户背景" prop="Background">
              <div class="upload-img-form">
                <el-upload
                  class="upload-img"
                  :auto-upload="false"
                  action="xxx"
                  list-type="picture"
                  :show-file-list="false"
                  :on-change="uphandleBackgroundChange"
                  :style="{
                    backgroundImage:
                      'url(' +
                      baseBackgroundUrl +
                      editForm.EditBackground +
                      ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'contain',
                  }"
                  accept="image/png, image/gif, image/jpg, image/jpeg"
                >
                  <i
                    v-show="!editForm.EditBackground"
                    class="el-icon-upload avatar-uploader-icon"
                  ></i>
                  <i
                    v-show="editForm.EditBackground"
                    class="el-icon-refresh avatar-uploader-icon"
                  ></i>
                  <div
                    v-show="!editForm.EditBackground"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadImgLabel") }}
                  </div>
                  <div
                    v-show="editForm.EditBackground"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadChoose") }}
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item :label="$t('ShareCover')" prop="ShareCover">
              <div class="upload-img-form">
                <el-upload
                  class="upload-img"
                  :auto-upload="false"
                  action="xxx"
                  list-type="picture"
                  :show-file-list="false"
                  :on-change="uphandleShareChange"
                  :style="{
                    backgroundImage:
                      'url(' +
                      baseShareCoverUrl +
                      editForm.EditShareCover +
                      ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'contain',
                  }"
                  accept="image/png, image/gif, image/jpg, image/jpeg"
                >
                  <i
                    v-show="!editForm.EditShareCover"
                    class="el-icon-upload avatar-uploader-icon"
                  ></i>
                  <i
                    v-show="editForm.EditShareCover"
                    class="el-icon-refresh avatar-uploader-icon"
                  ></i>
                  <div
                    v-show="!editForm.EditShareCover"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadImgLabel") }}
                  </div>
                  <div
                    v-show="editForm.EditShareCover"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadChoose") }}
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('Mode')"
              prop="Mode"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Mode'),
              }"
            >
              <el-select v-model="editForm.Mode" placeholder="Select Mode">
                <el-option
                  v-for="(value, key) in $t('Order.ModeList')"
                  :key="key"
                  :label="value"
                  :value="parseInt(key)"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('Shop.Area')"
              prop="AreaId"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Shop.Area'),
              }"
            >
              <el-select v-model="editForm.AreaId" placeholder="Select Area">
                <el-option
                  v-for="item in areaList"
                  :key="item.Id"
                  :label="field(item.Name)"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('TypeName')">
              <el-select
                v-model="editForm.TypeIds"
                multiple
                placeholder="Select Type"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.Id"
                  :label="field(item.Name)"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="可派店ID"
              prop="Business_Id"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + '可派店ID',
              }"
            >
              <el-input
                v-model.number="editForm.Business_Id"
                type="text"
                style="width: 150px"
              ></el-input
              >&nbsp;
              <el-button
                type="primary"
                icon="el-icon-search"
                :loading="businessLoading"
                circle
                @click.native="verifyBusinessId(editForm.Business_Id)"
              ></el-button
              >&nbsp;{{ CheckBusienss.chineseName }}
            </el-form-item>
            <el-form-item :label="$t('Reco')">
              <el-switch v-model="editForm.Reco"></el-switch>
            </el-form-item>
            <el-form-item
              label="订单数量"
              prop="OrderNumber"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + '订单数量',
              }"
            >
              <el-input
                v-model.number="editForm.OrderNumber"
                type="text"
                style="width: 150px"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Cellphone')"
              prop="Cellphone"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Cellphone'),
              }"
            >
              <el-input
                v-model="editForm.Cellphone"
                maxlength="13"
                style="width: 150px"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Address')"
              prop="Address"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Address'),
              }"
            >
              <el-input v-model="editForm.Address">
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click.native="openGetLocation()"
                ></el-button
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('ZipCode')"
              prop="ZipCode"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('ZipCode'),
              }"
            >
              <el-input
                v-model="editForm.ZipCode"
                style="width: 150px"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Shop.LowestPrice')"
              prop="LowestPrice"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Shop.LowestPrice'),
              }"
            >
              <el-input-number
                v-model.number="editForm.LowestPrice"
                :precision="2"
                :step="0.1"
                :max="9999"
                style="width: 195px"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              :label="$t('Shop.FreightDerate')"
              prop="FreightDerate"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Shop.FreightDerate'),
              }"
            >
              <el-input
                v-model.number="editForm.FreightDerate"
                max="100"
                style="width: 195px"
              >
                <template slot="append">%</template></el-input
              >
            </el-form-item>
            <el-form-item
              :label="$t('Shop.DeliveryModel')"
              prop="DeliveryModel"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Shop.DeliveryModel'),
              }"
            >
              <el-select
                v-model="editForm.DeliveryModel"
                placeholder="Select DeliveryModel"
              >
                <el-option
                  v-for="(value, key) in $t('Shop.DeliveryModelList')"
                  :key="key"
                  :label="value"
                  :value="parseInt(key)"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="自送价格"
              prop="DeliverPrice"
              v-if="editForm.DeliveryModel == 3 || editForm.DeliveryModel == 4"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Shop.Distance'),
              }"
            >
              <el-input-number
                v-model.number="editForm.DeliverPrice"
                :precision="2"
                :step="0.1"
                :max="20"
                style="width: 195px"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="自送范围(公里)'"
              v-if="editForm.DeliveryModel == 4"
              prop="Distance"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Shop.Distance'),
              }"
            >
              <el-input-number
                v-model.number="editForm.Distance"
                :precision="2"
                :step="0.1"
                :max="9999"
                style="width: 195px"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="GST"
              prop="Gst"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + 'GST',
              }"
            >
              <el-input
                v-model.number="editForm.Gst"
                maxlength="2"
                max="100"
                style="width: 195px"
              >
                <template slot="append">%</template></el-input
              >
            </el-form-item>
            <el-form-item label="客户自取">
              <el-switch v-model="editForm.Buffet"></el-switch>
            </el-form-item>
            <el-form-item
              label="自取折扣"
              prop="BuffetDiscount"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + '自取折扣',
              }"
              v-if="editForm.Buffet"
            >
              <el-input-number
                v-model.number="editForm.BuffetDiscount"
                :precision="2"
                :step="0.1"
                :max="1"
                style="width: 195px"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="提成比例"
              prop="Commission"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + '提成比例',
              }"
            >
              <el-input
                v-model.number="editForm.Commission"
                maxlength="3"
                max="100"
                style="width: 195px"
              >
                <template slot="append">%</template></el-input
              >
            </el-form-item>
            <el-form-item label="银行名" prop="BankName">
              <el-input v-model="editForm.BankName"></el-input>
            </el-form-item>
            <el-form-item label="银行账号" prop="Account">
              <el-input v-model="editForm.Account"></el-input>
            </el-form-item>
            <el-form-item label="开户名" prop="AccountName">
              <el-input v-model="editForm.AccountName"></el-input>
            </el-form-item>
            <el-form-item label="公告通知">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2 }"
                v-model="editForm.Notice"
                maxlength="100"
              ></el-input>
            </el-form-item>
            <el-form-item label="拼单加入通知">
              <el-switch v-model="editForm.TourDiyInform"></el-switch>
            </el-form-item>
            <el-form-item label="推文链接">
              <el-input
                v-model="editForm.ArticleLink"
                maxlength="200"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('Shop.Intro')">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2 }"
                v-model="editForm.Intro[slot.langkey]"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('Remark')">
              <el-input
                type="textarea"
                v-model="editForm.Remark"
                :autosize="{ minRows: 2 }"
              ></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-switch v-model="editForm.Enabled"></el-switch>
            </el-form-item>
          </template>
          <template v-slot:other="slot">
            <el-form-item :label="$t('Name')">
              <el-input v-model="editForm.Name[slot.item.key]"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Shop.Intro')">
              <el-input
                type="textarea"
                :rows="2"
                v-model="editForm.Intro[slot.item.key]"
              ></el-input>
            </el-form-item>
          </template>
        </LangTabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="150px" ref="addForm" size="small">
        <LangTabs>
          <template v-slot:main="slot">
            <el-form-item
              :label="$t('Name')"
              :prop="'Name.' + slot.langkey"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Name'),
              }"
            >
              <el-input v-model="addForm.Name[slot.langkey]"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Cover')"
              prop="Cover"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Cover'),
              }"
            >
              <div class="upload-img-form">
                <el-upload
                  class="upload-img"
                  :auto-upload="false"
                  action="xxx"
                  list-type="picture"
                  :show-file-list="false"
                  :on-change="handleChange"
                  :style="{
                    backgroundImage: 'url(' + addForm.Cover + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'contain',
                  }"
                  accept="image/png, image/gif, image/jpg, image/jpeg"
                >
                  <i
                    v-show="!addForm.Cover"
                    class="el-icon-upload avatar-uploader-icon"
                  ></i>
                  <i
                    v-show="addForm.Cover"
                    class="el-icon-refresh avatar-uploader-icon"
                  ></i>
                  <div
                    v-show="!addForm.Cover"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadImgLabel") }}
                  </div>
                  <div
                    v-show="addForm.Cover"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadChoose") }}
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="商户背景" prop="Background">
              <div class="upload-img-form">
                <el-upload
                  class="upload-img"
                  :auto-upload="false"
                  action="xxx"
                  list-type="picture"
                  :show-file-list="false"
                  :on-change="handleBackgroundChange"
                  :style="{
                    backgroundImage: 'url(' + addForm.Background + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'contain',
                  }"
                  accept="image/png, image/gif, image/jpg, image/jpeg"
                >
                  <i
                    v-show="!addForm.Background"
                    class="el-icon-upload avatar-uploader-icon"
                  ></i>
                  <i
                    v-show="addForm.Background"
                    class="el-icon-refresh avatar-uploader-icon"
                  ></i>
                  <div
                    v-show="!addForm.Background"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadImgLabel") }}
                  </div>
                  <div
                    v-show="addForm.Background"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadChoose") }}
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item :label="$t('ShareCover')" prop="ShareCover">
              <div class="upload-img-form">
                <el-upload
                  class="upload-img"
                  :auto-upload="false"
                  action="xxx"
                  list-type="picture"
                  :show-file-list="false"
                  :on-change="handleShareChange"
                  :style="{
                    backgroundImage: 'url(' + addForm.ShareCover + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'contain',
                  }"
                  accept="image/png, image/gif, image/jpg, image/jpeg"
                >
                  <i
                    v-show="!addForm.ShareCover"
                    class="el-icon-upload avatar-uploader-icon"
                  ></i>
                  <i
                    v-show="addForm.ShareCover"
                    class="el-icon-refresh avatar-uploader-icon"
                  ></i>
                  <div
                    v-show="!addForm.ShareCover"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadImgLabel") }}
                  </div>
                  <div
                    v-show="addForm.ShareCover"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadChoose") }}
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('Mode')"
              prop="Mode"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Mode'),
              }"
            >
              <el-select v-model="addForm.Mode" placeholder="Select Mode">
                <el-option
                  v-for="(value, key) in $t('Order.ModeList')"
                  :key="key"
                  :label="value"
                  :value="parseInt(key)"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('Shop.Area')"
              prop="AreaId"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Shop.Area'),
              }"
            >
              <el-select v-model="addForm.AreaId" placeholder="Select Area">
                <el-option
                  v-for="item in areaList"
                  :key="item.Id"
                  :label="field(item.Name)"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('TypeName')">
              <el-select
                v-model="addForm.TypeIds"
                multiple
                placeholder="Select Type"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.Id"
                  :label="field(item.Name)"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="可派店ID"
              prop="Business_Id"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + '可派店ID',
              }"
            >
              <el-input
                v-model.number="addForm.Business_Id"
                type="text"
                style="width: 150px"
              ></el-input
              >&nbsp;
              <el-button
                type="primary"
                icon="el-icon-search"
                :loading="businessLoading"
                circle
                @click.native="verifyBusinessId(addForm.Business_Id)"
              ></el-button
              >&nbsp;{{ CheckBusienss.chineseName }}
            </el-form-item>
            <el-form-item :label="$t('Reco')">
              <el-switch v-model="addForm.Reco"></el-switch>
            </el-form-item>
            <el-form-item
              label="订单数量"
              prop="OrderNumber"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + '订单数量',
              }"
            >
              <el-input
                v-model.number="addForm.OrderNumber"
                type="text"
                style="width: 150px"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Cellphone')"
              prop="Cellphone"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Cellphone'),
              }"
            >
              <el-input
                v-model="addForm.Cellphone"
                maxlength="13"
                style="width: 150px"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Address')"
              prop="Address"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Address'),
              }"
            >
              <el-input v-model="addForm.Address">
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click.native="openGetLocation()"
                ></el-button
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('ZipCode')"
              prop="ZipCode"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('ZipCode'),
              }"
            >
              <el-input
                v-model="addForm.ZipCode"
                style="width: 150px"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Shop.LowestPrice')"
              prop="LowestPrice"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Shop.LowestPrice'),
              }"
            >
              <el-input-number
                v-model.number="addForm.LowestPrice"
                :precision="2"
                :step="0.1"
                :max="9999"
                style="width: 195px"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              :label="$t('Shop.FreightDerate')"
              prop="FreightDerate"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Shop.FreightDerate'),
              }"
            >
              <el-input
                v-model.number="addForm.FreightDerate"
                max="100"
                style="width: 195px"
              >
                <template slot="append">%</template></el-input
              >
            </el-form-item>
            <el-form-item
              :label="$t('Shop.DeliveryModel')"
              prop="DeliveryModel"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Shop.DeliveryModel'),
              }"
            >
              <el-select
                v-model="addForm.DeliveryModel"
                placeholder="Select DeliveryModel"
              >
                <el-option
                  v-for="(value, key) in $t('Shop.DeliveryModelList')"
                  :key="key"
                  :label="value"
                  :value="parseInt(key)"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="自送价格"
              prop="DeliverPrice"
              v-if="addForm.DeliveryModel == 3 || addForm.DeliveryModel == 4"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Shop.Distance'),
              }"
            >
              <el-input-number
                v-model.number="addForm.DeliverPrice"
                :precision="2"
                :step="0.1"
                :max="20"
                style="width: 195px"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="自送范围(公里)'"
              v-if="addForm.DeliveryModel == 4"
              prop="Distance"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Shop.Distance'),
              }"
            >
              <el-input-number
                v-model.number="addForm.Distance"
                :precision="2"
                :step="0.1"
                :max="9999"
                style="width: 195px"
              ></el-input-number>
            </el-form-item>

            <el-form-item
              label="GST"
              prop="Gst"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + 'GST',
              }"
            >
              <el-input
                v-model.number="addForm.Gst"
                maxlength="2"
                max="100"
                style="width: 195px"
              >
                <template slot="append">%</template></el-input
              >
            </el-form-item>
            <el-form-item label="客户自取">
              <el-switch v-model="addForm.Buffet"></el-switch>
            </el-form-item>
            <el-form-item
              label="自取折扣"
              prop="BuffetDiscount"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + '自取折扣',
              }"
              v-if="addForm.Buffet"
            >
              <el-input-number
                v-model.number="addForm.BuffetDiscount"
                :precision="2"
                :step="0.1"
                :max="1"
                style="width: 195px"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="提成比例"
              prop="Commission"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + '提成比例',
              }"
            >
              <el-input
                v-model.number="addForm.Commission"
                maxlength="3"
                max="100"
                style="width: 195px"
              >
                <template slot="append">%</template></el-input
              >
            </el-form-item>
            <el-form-item label="银行名" prop="BankName">
              <el-input v-model="addForm.BankName"></el-input>
            </el-form-item>
            <el-form-item label="银行账号" prop="Account">
              <el-input v-model="addForm.Account"></el-input>
            </el-form-item>
            <el-form-item label="开户名" prop="AccountName">
              <el-input v-model="editForm.AccountName"></el-input>
            </el-form-item>
            <el-form-item label="公告通知">
              <el-input
                type="textarea"
                :rows="2"
                v-model="addForm.Notice"
                maxlength="100"
              ></el-input>
            </el-form-item>
            <el-form-item label="拼单加入通知">
              <el-switch v-model="addForm.TourDiyInform"></el-switch>
            </el-form-item>
            <el-form-item label="推文链接">
              <el-input
                v-model="addForm.ArticleLink"
                maxlength="200"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('Shop.Intro')">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2 }"
                v-model="addForm.Intro[slot.langkey]"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('Remark')">
              <el-input
                type="textarea"
                v-model="addForm.Remark"
                :autosize="{ minRows: 2 }"
              ></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-switch v-model="addForm.Enabled"></el-switch>
            </el-form-item>
          </template>
          <template v-slot:other="slot">
            <el-form-item :label="$t('Name')">
              <el-input v-model="addForm.Name[slot.item.key]"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Shop.Intro')">
              <el-input
                type="textarea"
                :rows="2"
                v-model="addForm.Intro[slot.item.key]"
              ></el-input>
            </el-form-item>
          </template>
        </LangTabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <!--二维码-->
    <el-dialog
      title="小程序码"
      :visible.sync="qrCodeVisible"
      v-model="qrCodeVisible"
      :close-on-click-modal="false"
      width="30%"
    >
      <div class="imgdiv">
        <el-image class="imgqrcode" :src="qrCodeSrc" lazy
          ><div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i></div
        ></el-image>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="qrCodeVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <!--选择地址-->
    <el-dialog
      title="选择地址"
      :visible.sync="LocationVisible"
      v-model="LocationVisible"
      :close-on-click-modal="false"
      append-to-body
      width="40%"
    >
      <div class="toolbarWrapper">
        <el-form
          :inline="true"
          @submit.native.prevent
          size="small"
          class="comptoolbar"
        >
          <el-form-item>
            <el-input
              v-model="selectAdderssKey"
              :placeholder="$t('EnterContent')"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="selectAddress()">查找</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!--列表-->
      <el-table
        :data="addresslist"
        highlight-current-row
        v-loading="addresslistLoading"
        style="width: 100%"
        size="small"
        @row-dblclick="addressHandle"
      >
        <el-table-column label="Address">
          <template slot-scope="scope">
            {{ scope.row.BuilDing }} {{ scope.row.Address }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="LocationVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <ShopLabel ref="shopLabelDialog"></ShopLabel>
    <Product ref="shopProductDialog"></Product>
    <ShippingTime ref="shippingTimeDialog"></ShippingTime>
    <ShopDerate ref="shopDerateDialog"></ShopDerate>
    <ShopFirstDerate ref="shopFirstDerateDialog"></ShopFirstDerate>
  </section>
</template>

<script>
import ShopLabel from "../ShopConfig/ShopLabel";
import Product from "../ShopConfig/Product";
import ShippingTime from "../ShopConfig/ShippingTime";
import ShopDerate from "../ShopConfig/ShopDerate";
import ShopFirstDerate from "../ShopConfig/ShopFirstDerate";
import util from "util/date";
import {
  base,
  getLocation,
  getShopBasis,
  getShopListPage,
  removeShop,
  editShop,
  addShop,
  verifyBusinessId,
  shopResetWeight,
} from "@/api/api";
import { getButtonList } from "@/promissionRouter";
export default {
  components: {
    ShopLabel,
    Product,
    ShippingTime,
    ShopDerate,
    ShopFirstDerate,
  },
  data() {
    return {
      filters: {
        Name: "",
      },
      buttonList: [],
      list: [],
      total: 0,
      page: 1,
      listLoading: false,
      currentRow: null,
      areaList: [],
      typeList: [],
      businessList: [],
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      //编辑界面数据
      editForm: {},
      baseCoverUrl: base + "/FileUpload/ShopCover/b0/",
      baseEditCoverUrl: base + "/FileUpload/ShopCover/b0/",
      baseShareCoverUrl: base + "/FileUpload/ShopCover/b0/",
      baseBackgroundUrl: base + "/FileUpload/ShopBackground/a0/",
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      //新增界面数据
      addForm: { Name: {}, Intro: {}, ListIntro: {} },
      qrCodeVisible: false,
      qrCodeUrl: base + "/admin/Shop/GetQRCodeImage?id=",
      qrCodeSrc: "",
      motorcadeList: [{ Id: 0, Name: "无车队" }],
      CheckBusienss: { chineseName: "" },
      businessLoading: false,
      LocationVisible: false,
      selectAdderssKey: "",
      addresslist: [],
      addresslistLoading: false,
    };
  },
  methods: {
    openQrCode(id, type) {
      this.qrCodeSrc = this.qrCodeUrl + id + "&type=" + type;
      this.qrCodeVisible = true;
    },
    verifyBusinessId(id) {
      if (id == "") {
        return;
      }
      let para = {
        bid: id,
      };
      this.businessLoading = true;
      verifyBusinessId(para).then((res) => {
        this.CheckBusienss = res.data.response;
        if (!res.data.response.chineseName) {
          this.CheckBusienss.chineseName = "未找到";
        }
        this.businessLoading = false;
      });
    },
    openGetLocation() {
      this.LocationVisible = true;
    },
    selectAddress() {
      let _this = this;
      let para = {
        key: this.selectAdderssKey,
      };
      this.addresslistLoading = true;
      getLocation(para).then((res) => {
        this.addresslist = res.data.results;
        this.addresslistLoading = false;
      });
    },
    addressHandle(row, event, column) {
      this.addForm.Address = row.Address;
      this.addForm.ZipCode = row.Postal;
      this.addForm.latitude = parseFloat(row.Latitude);
      this.addForm.longitude = parseFloat(row.Longitude);

      this.editForm.Address = row.Address;
      this.editForm.ZipCode = row.Postal;
      this.editForm.latitude = parseFloat(row.Latitude);
      this.editForm.longitude = parseFloat(row.Longitude);

      this.LocationVisible = false;
    },
    // 图片预览
    uphandleChange(file) {
      this.baseEditCoverUrl = "";
      this.editForm.EditCover = file.url;
      this.getBase64(file.raw).then((res) => {
        this.editForm.CoverFile = res;
      });
      this.$refs["editForm"].validateField("EditCover");
    },
    // 图片预览
    handleChange(file) {
      this.addForm.Cover = file.url;
      this.getBase64(file.raw).then((res) => {
        this.addForm.CoverFile = res;
      });
      this.$refs["addForm"].validateField("Cover");
    },
    // 分享图片预览
    uphandleShareChange(file) {
      this.baseShareCoverUrl = "";
      this.editForm.EditShareCover = file.url;
      this.getBase64(file.raw).then((res) => {
        this.editForm.ShareCoverFile = res;
      });
    },
    // 分享图片预览
    handleShareChange(file) {
      this.addForm.ShareCover = file.url;
      this.getBase64(file.raw).then((res) => {
        this.addForm.ShareCoverFile = res;
      });
    },
    handleBackgroundChange(file) {
      this.addForm.Background = file.url;
      this.getBase64(file.raw).then((res) => {
        this.addForm.BackgroundFile = res;
      });
    },
    uphandleBackgroundChange(file) {
      this.baseBackgroundUrl = "";
      this.editForm.EditBackground = file.url;
      this.getBase64(file.raw).then((res) => {
        this.editForm.BackgroundFile = res;
      });
    },
    openProduct(name, id) {
      this.$refs.shopProductDialog.loadData(name, id);
    },
    openShippingTime(name, id) {
      this.$refs.shippingTimeDialog.loadData(name, id);
    },
    openShopDerate(name, id) {
      this.$refs.shopDerateDialog.loadData(name, id);
    },
    openShopFirstDerate(name, id) {
      this.$refs.shopFirstDerateDialog.loadData(name, id);
    },
    openShopLabel(name, id) {
      this.$refs.shopLabelDialog.loadData(name, id);
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        Name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd");
    },
    searchList() {
      this.page = 1;
      this.getList();
    },
    //获取列表
    getList() {
      let _this = this;
      let para = {
        key: this.filters.Name,
        page: this.page,
      };
      this.listLoading = true;
      getShopListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
    ResetWeight() {
      this.$confirm("确认重新计算权重吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          shopResetWeight().then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: "成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getList();
          });
        })
        .catch(() => {});
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeShop(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getList();
          });
        })
        .catch(() => {});
    },
    //显示编辑活动界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }

      this.editForm = Object.assign({}, this.clone(row));
      this.editForm.FreightDerate = parseInt(this.editForm.FreightDerate * 100);
      this.editForm.Commission = parseInt(this.editForm.Commission * 100);
      this.editForm.Gst = parseInt(this.editForm.Gst * 100);
      this.editForm.EditCover = this.editForm.Cover;
      this.editForm.EditShareCover = this.editForm.ShareCover;
      this.editForm.EditBackground = this.editForm.Background;
      this.editForm.CoverFile = "";
      this.editForm.ShareCoverFile = "";
      this.baseEditCoverUrl = base + "/FileUpload/ShopCover/b0/";
      this.baseShareCoverUrl = base + "/FileUpload/ShopCover/b0/";
      this.baseBackgroundUrl = base + "/FileUpload/ShopBackground/a0/";
      this.editFormVisible = true;
      this.CheckBusienss = { chineseName: "" };
    },
    //编辑活动
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {})
            .then(() => {
              this.editLoading = true;
              let para = Object.assign({}, this.editForm);
              editShop(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.editLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.editLoading = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.$refs.listTable.setCurrentRow();
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    //显示新增活动界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        Name: {},
        Cover: "",
        CoverFile: null,
        ShareCover: "",
        ShareCoverFile: null,
        Background: "",
        BackgroundFile: null,
        ArticleLink: "",
        Cellphone: "",
        Address: "",
        ZipCode: "",
        Intro: {},
        ListIntro: {},
        Reco: false,
        ShareLink: "",
        OrderNumber: 0,
        LowestPrice: 20.0,
        FreightDerate: 10,
        Distance: 0,
        DeliverPrice: 0,
        Gst: 7,
        Commission: 10,
        BankName: "",
        Account: "",
        AccountName: "",
        TourDiyInform: true,
        longitude: 0,
        latitude: 0,
        TypeIds: [],
        BusinessIds: [],
        Enabled: true,
        Detailed: {},
      };
      this.CheckBusienss = { chineseName: "" };
    },
    //新增活动
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {})
            .then(() => {
              this.addLoading = true;
              let para = Object.assign({}, this.addForm);
              addShop(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.addLoading = false;
                  return;
                }
                this.addLoading = false;
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
  },
  mounted() {
    getShopBasis().then((res) => {
      this.areaList = res.data.response.areaList;
      this.typeList = res.data.response.typeList;
      this.motorcadeList = this.motorcadeList.concat(
        res.data.response.motorcadeList
      );
      this.getList();
    });

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>
<style>
.imgqrcode {
  width: 300px;
  height: 300px;
}
.imgdiv {
  display: flex;
  align-content: center;
  text-align: center;
  justify-content: center;
}
.shopurl {
  margin-bottom: 10px;
}
</style>
